var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('p',{staticClass:"text-md-center"},[_vm._v("Redirecionando para a edição do seus dados cadastrais.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }